module.exports = __webpack_public_path__ + "static/media/charts-pdf-footer-image3.017bf735.PNG";